import { Constants } from '@bingads-webui-clientcenter/entity-utils';

import { Severity } from '../constants';

const { DeliveryStatus } = Constants;

export const getNodeSeverity = ({ deliveryStatus }) => {
  switch (DeliveryStatus[deliveryStatus]) {
    case DeliveryStatus.CampaignBudgetPaused:
      return Severity.Error;
    case DeliveryStatus.BudgetSuggestions:
      return Severity.Warning;
    default:
      return undefined;
  }
};

export const getNodeIconTooltipText = ({ deliveryStatus }, i18n) => {
  switch (DeliveryStatus[deliveryStatus]) {
    case DeliveryStatus.CampaignBudgetPaused:
      return i18n.getString(_TL_('Out of budget'));
    case DeliveryStatus.BudgetSuggestions:
      return i18n.getString(_TL_('Limited by budget'));
    default:
      return undefined;
  }
};
